/* hs-eslint ignored failing-rules */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { AVATAR_SIZES, AVATAR_TYPES } from './Constants';
import { getAvatarResolver } from './AvatarResolver';
import { fetchImage, isFetched } from './lib/Image';
import LookupRecord from './Records/LookupRecord';
import defaultFetchAvatars from './api/defaultFetchAvatars';
import defaultPortalId from './lib/defaultPortalId';
import { computeSizeProp } from './lib/compat';
import UIAvatarDisplay from './UIAvatarDisplay/UIAvatarDisplay';
const default_no_avatar = [/hubfs\/defaults\/contact\.png/, /hubfs\/defaults\/company\.png/, /avatar\/hash\/4bd0df0db6227e87de4031baa4422b73/, /avatar\/hash\/cc7a027acb4f854bd9b1d3a511d1740c/, /avatar\/hash\/5be48140e95ae69927946a77d6c29d1a/, /avatars\.s3\.amazonaws\/default-100/, /hubspot-avatars\.s3\.amazonaws\.com\/default-100/];
const resolver = getAvatarResolver();
const DEFAULT_LOOKUP_RECORD = new LookupRecord();
export default class UIAvatarRequest extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      lookupRecord: DEFAULT_LOOKUP_RECORD,
      avatarURI: undefined,
      error: undefined,
      loaded: false
    };

    this.handleResolverUpdate = () => {
      this.updateAvatarUrl(this.props);
    };

    this.startWatching = () => {
      resolver.watch(this.handleResolverUpdate);
    };

    this.stopWatching = () => {
      resolver.unwatch(this.handleResolverUpdate);
    };

    this.updateAvatarUrl = props => {
      const size = computeSizeProp(props.size);
      const lookupValues = Object.assign({}, this.makeLookupValues());

      if (!lookupValues.primaryIdentifier || lookupValues.primaryIdentifier.length < 1 || 'deal' === lookupValues.type.toLowerCase() || 'ticket' === lookupValues.type.toLowerCase()) {
        this.setState({
          loaded: true
        });
        return undefined;
      }

      const lookupRecordFromProps = new LookupRecord(Object.assign({}, lookupValues, {
        existsInPortal: props.existsInPortal,
        portalId: props.portalId,
        dimensions: AVATAR_SIZES[size] !== AVATAR_SIZES.responsive ? AVATAR_SIZES[size] : AVATAR_SIZES.xl
      }));
      const lookupRecord = this.state.lookupRecord.equals(lookupRecordFromProps) ? this.state.lookupRecord : lookupRecordFromProps;
      const avatarURI = resolver.getAvatarURI(lookupRecord, props.fetchAvatars, props.portalId);
      const fetched = isFetched(avatarURI);
      const isDefault = typeof avatarURI !== 'string';
      const loaded = isDefault || fetched;

      if (this.state.avatarURI === avatarURI) {
        return null;
      }

      this.setState({
        avatarURI,
        lookupRecord,
        error: undefined,
        loaded
      });

      if (loaded) {
        return null;
      } // Forces the browser to load the image into the cache to avoid UI-jitters
      // as the image loads in.


      fetchImage(avatarURI).then(() => {
        if (this._isMounted && this.state.avatarURI === avatarURI) {
          this.setState({
            loaded: true
          });
        }
      }).catch(error => {
        if (this._isMounted && this.state.avatarURI === avatarURI) {
          this.setState({
            error
          });
        }
      });
      return null;
    };

    this.getSrc = () => {
      const {
        avatarURI,
        error,
        loaded
      } = this.state;
      const {
        src
      } = this.props;

      if (src) {
        return src;
      }

      if (avatarURI) {
        if (avatarURI && loaded && !error && default_no_avatar.filter(regex => regex.test(avatarURI)).length > 0) {
          return undefined;
        } else if (avatarURI && loaded && !error) {
          return avatarURI;
        }
      }

      return undefined;
    };

    this.makeLookupValues = () => {
      const {
        _isHasMore,
        companyId,
        domain,
        email,
        fileManagerKey,
        hubSpotUserEmail,
        productId,
        type,
        vid,
        primaryIdentifier,
        secondaryIdentifier
      } = this.props;
      const selfie = [{
        companyId
      }, {
        domain
      }, {
        email
      }, {
        hubSpotUserEmail
      }, {
        productId
      }, {
        vid
      }].filter(value => value[Object.keys(value)[0]])[0];

      if (_isHasMore) {
        return {
          type: '_isHasMore'
        };
      }

      if (primaryIdentifier && secondaryIdentifier && type) {
        return {
          type,
          primaryIdentifier,
          secondaryIdentifier
        };
      }

      if (type && primaryIdentifier) {
        return {
          type,
          primaryIdentifier
        };
      } // quickest BE response…probably


      if (vid && email && fileManagerKey) {
        return {
          type: 'contact',
          primaryIdentifier: vid,
          secondaryIdentifier: email,
          fileManagerKey
        };
      }

      if (vid && email) {
        return {
          type: 'vid',
          primaryIdentifier: vid,
          secondaryIdentifier: email
        };
      } // quickest BE response…probably


      if (companyId && domain && fileManagerKey) {
        return {
          type: 'company',
          primaryIdentifier: companyId,
          secondaryIdentifier: domain,
          fileManagerKey
        };
      } // If we have type


      if (type === 'enrichmentDomain') {
        return (primaryIdentifier || domain) && {
          type,
          primaryIdentifier: primaryIdentifier || domain
        };
      }

      if (Object.keys(AVATAR_TYPES).filter(t => t === type).length > 0 && selfie) {
        return {
          type,
          primaryIdentifier: Object.keys(selfie).map(e => selfie[e])[0]
        };
      }

      if (selfie) {
        return {
          type: Object.keys(selfie)[0],
          primaryIdentifier: Object.keys(selfie).map(e => selfie[e])[0]
        };
      }

      return {};
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.startWatching();
    this.updateAvatarUrl(this.props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidUpdate() {
    this.updateAvatarUrl(this.props);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.stopWatching();
  }

  render() {
    const {
      _isHasMore,
      _isHasTooltip,
      _isHoverlayOpen,
      _isListReversed,
      _toolTipOverWrite,
      _noDefaultSrc,
      children,
      className,
      displayName,
      href,
      isHoverlay,
      onClick,
      size,
      socialNetwork,
      style,
      textSpacing,
      truncateLength,
      type,
      toolTipPlacement
    } = this.props;
    const src = this.getSrc();

    if (_noDefaultSrc && !src) {
      return children ? /*#__PURE__*/_jsx("div", {
        onClick: onClick,
        children: children
      }) : /*#__PURE__*/_jsx("noscript", {});
    }

    return /*#__PURE__*/_jsx(UIAvatarDisplay, Object.assign({}, {
      _isHasMore,
      _isHasTooltip,
      _isHoverlayOpen,
      _isListReversed,
      _toolTipOverWrite,
      children,
      className,
      displayName,
      href,
      isHoverlay,
      onClick,
      size,
      socialNetwork,
      src,
      style,
      textSpacing,
      truncateLength,
      type: type || this.makeLookupValues().type,
      toolTipPlacement
    }));
  }

}
UIAvatarRequest.defaultProps = {
  size: 'sm',
  portalId: defaultPortalId(),
  fetchAvatars: defaultFetchAvatars,
  isAuthed: true
};